//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'

import makeDebug from 'debug'
import qs from 'qs'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
const debug = makeDebug('plp:crown-module')
import RbDynamicSwiperSlide from '@/elements/smart-container/dynamic-swiper-slide'
export default {
  name: 'rb-crown-module',
  components: {
    RbDynamicSwiperSlide,
  },
  data: function () {
    return {
      firstTime: true,
      visible: false,
    }
  },
  computed: {
    swiperSlides() {
      return this.$slots.default?.filter((slot) => !!slot.tag)
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    swiperConfig() {
      return {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 8,
      }
    },
  },
  /* computed: {
    ...mapGettersPlp(['facetsAvailable']),
  },
  watch: {
    facetsAvailable() {
      !this.firstTime && this.removeCrownModule()
      this.firstTime = false
    },
  }, */
  mounted() {
    this.$nextTick(() => {
      document.querySelector('.skeleton-crown-module')?.remove()
    })

    const queryParams = qs.parse(window.location.search)
    const facets = get(queryParams, '?facet', null)
    const orderBy = get(queryParams, '?orderBy', null)
    debug('Facets %o', facets)
    debug('OrderBy %o', orderBy)
    if (!facets && !orderBy) {
      this.visible = true
    }
  },
  methods: {
    removeCrownModule() {
      debug('removing crown module')
      this.visible = false
    },
  },
}
